import React from "react";

export default function StacksWindowContent({ projects }) {
  return (
    <div className="stackCloud">
      {projects.flatMap((project) => project.stack).map((tech, index) => (
        <span key={`${tech}-${index}`}>{tech}</span>
      ))}
    </div>
  );
}
